/**
 * Pinecone injects route HTML without reliably executing inline <script> tags.
 * Wire the magic-link reset form after each navigation (and on standalone auth shells).
 */
function bindAdminResetPasswordFormOnce() {
  const form = document.getElementById('adminResetPwForm');
  if (!form || form.dataset.pdlBound === '1') return;
  form.dataset.pdlBound = '1';

  const errEl = document.getElementById('rpErr');
  const okEl = document.getElementById('rpOk');
  const btn = document.getElementById('rpSubmit');

  function tokenFromUrl() {
    try {
      return new URL(globalThis.location.href).searchParams.get('token') || '';
    } catch {
      return '';
    }
  }

  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    if (errEl) errEl.textContent = '';
    if (okEl) okEl.textContent = '';
    const t = String(tokenFromUrl() || '').trim();
    const a = String(document.getElementById('rpPw')?.value || '');
    const b = String(document.getElementById('rpPw2')?.value || '');
    if (a.length < 8) {
      if (errEl) errEl.textContent = 'Password must be at least 8 characters.';
      return;
    }
    if (a !== b) {
      if (errEl) errEl.textContent = 'Passwords do not match.';
      return;
    }
    if (!t) {
      if (errEl) errEl.textContent = 'Missing reset token. Open the link from your email or request a new one.';
      return;
    }
    if (btn) btn.disabled = true;
    let doneOk = false;
    fetch('/api/auth/reset-password', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ token: t, password: a }),
    })
      .then((r) => r.json().then((j) => ({ r, j })))
      .then(({ r, j }) => {
        if (!r.ok) throw new Error(j.message || j.error || 'reset_failed');
        doneOk = true;
        if (okEl) {
          okEl.textContent = j.message || 'Password updated. Redirecting to sign in…';
        }
        globalThis.setTimeout(() => {
          globalThis.location.href = '/admin/login';
        }, 1200);
      })
      .catch((e) => {
        if (errEl) errEl.textContent = String(e?.message || 'reset_failed');
      })
      .finally(() => {
        if (btn && !doneOk) btn.disabled = false;
      });
  });
}

document.addEventListener('pinecone:after', () => {
  queueMicrotask(bindAdminResetPasswordFormOnce);
});

queueMicrotask(bindAdminResetPasswordFormOnce);
